import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import memoize from 'lodash/memoize';
import { getSections, getCurrentBreadcrumbs } from './questions';

export const getListProps = createSelector(
  [getSections, getCurrentBreadcrumbs],
  (sections, currentBreadcrumb) => memoize( sectionIndex => {
    if (isEmpty(currentBreadcrumb)) {
      return {}
    }
    const currentSection = sections[currentBreadcrumb.id];
    const listQuestion = currentSection[sectionIndex]
    if (listQuestion) {
      const { isList, listDisplay, hasItems, addButtonText, originalQuestions, questionObj } = listQuestion.list;
      return {
        isList,
        listDisplay,
        hasItems,
        addButtonText,
        originalQuestions,
        questionObj,
      }
    }
    return {}
  }),
)


/**
 * @description This function is supposed to provide the title for accordions.
 * This is limited to insurance and beneficiary. This should ideally come from backend,
 * but at the moment, custom code works fine.
 * @param {Array} listQuestion 
 */
export const getListTitle = (listQuestion) => {
  let title = '';
  try {
    // if insurance question
    if (listQuestion[0].question_id.match(/insurance/i)) {
      title = listQuestion[0].response
    }

    // if beneficiary or child rider question
    if (listQuestion[0].question_id.match(/beneficiary/i) ||
      listQuestion[0].question_id.match(/childrider/i)) {
      const firstName = listQuestion.filter(q => q.question_id.match(/firstname/i))[0];
      const lastName = listQuestion.filter(q => q.question_id.match(/lastname/i))[0];
      const allocQuestion = listQuestion.filter(q => q.question_id.match(/alloc/i))[0];
      if(lastName) {
        title = `${lastName.response}, `;
      }
      if(firstName) {
        title += `${firstName.response} `;
      }
      if(allocQuestion) {
        title +=  `(${allocQuestion.response}%)`;
      }
    }
  } catch (e) {
    // error.
    title = ''
  }
  return title;
}
